import { Host, Component, Prop, h, Event, EventEmitter, State, Element } from '@stencil/core';

@Component({
  tag: 'dda-split-button',
  // styleUrls: ['dda-split-button.css'],
  shadow: false,
})
export class DdaSplitButton {
  @Prop() text_button_type: string = 'button';
  @Prop() disabled: boolean = false;
  @Prop() start_icon_family: string = '';
  @Prop() start_icon: string = '';
  @Prop() button_text: string = '';
  @Prop() aria_label?: string = '';
  @Prop() button_color: string = 'primary';
  @Prop() size?: string;
  @Prop() button_shape?: string = '';
  @Prop() toggle_button_shape?: string = '';
  @Prop() gap?: number;
  @Prop() custom_class?: string = '';
  @Prop() component_mode?: string;
  @Prop() text_button_id: string;
  @Prop() text_button_name?: string = '';
  @Prop() value?: string;

  @Event() buttonClick: EventEmitter<{ event: MouseEvent, id: string, value: string, name: string }>;

  /*toogle Button*/
  @Element() el: HTMLElement;
  @State() is_open: boolean = false;

  private handleClick = (event: MouseEvent) => {
    if (this.disabled) return;

    this.buttonClick.emit({
      event,
      id: this.text_button_id,
      value: this.value,
      name: this.text_button_name,
    });
  };
 
  toggleSelect() {
    if (!this.disabled) {
      this.is_open = !this.is_open;
    }
  }
  handleClickOutside = (event: MouseEvent) => {
    if (this.is_open && !this.el.contains(event.target as Node)) {
      this.is_open = false;
    }
  };

  connectedCallback() {
    document.addEventListener('click', this.handleClickOutside);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  componentDidLoad() {
    // after first render, move slotted menu inside container
    this.moveMenuToContainer();
  }

  componentDidRender() {
    // ensure menu stays inside container after re-renders (defensive)
    this.moveMenuToContainer();
  }

  private moveMenuToContainer() {
    // find the visible container inside this component
    const container = this.el.querySelector('.split-btn-list') as HTMLElement | null;
    if (!container) return;

    // Only consider direct children of host that carry slot="menu".
    const hostChildren = Array.from(this.el.children) as Element[];
    const slotted = hostChildren.filter((c) => c.getAttribute && c.getAttribute('slot') === 'menu');

    slotted.forEach((node) => {
      // if it's already inside container, skip
      if (node.parentElement !== container) {
        container.appendChild(node);
      }
    });
  }



  render() {
  const textButtonClass = [
    'dda-split-btn',                  // unique for main button
    `btn-color-${this.button_color}`,
    this.size ? `btn-size-${this.size}` : '',
    this.button_shape ? `split-btn-main-shape-${this.button_shape}` : '',
    this.gap ? `dda-gap-${this.gap}` : '',
    this.custom_class,
    this.component_mode,
  ]
  .filter(Boolean)
  .join(' ');

  const toggleButtonClass = [
    'dda-split-btn dda-split-btn-toggle',                // unique for toggle button
    `btn-color-${this.button_color}`,
    this.size ? `btn-size-${this.size}` : '',
    this.button_shape ? `split-icon-btn-shape-${this.button_shape}` : '',
    this.gap ? `dda-gap-${this.gap}` : '',
    this.custom_class,
    this.component_mode,
  ]
  .filter(Boolean)
  .join(' ');

   const listClass = `split-btn-list ${this.is_open ? 'open' : 'closed'}`;

  return (
    <Host>
      <div class="split-btn-container">
        {/* Main action button */}
        <button
          id={this.text_button_id}
          type={this.text_button_type}
          class={textButtonClass}
          disabled={this.disabled}
          aria-label={this.aria_label || this.button_text}
          name={this.text_button_name}
          value={this.value}
          onClick={this.handleClick}
        >
          {this.start_icon && (
            <i class="material-icons material-symbols-outlined" aria-hidden="true">
              {this.start_icon}
            </i>
          )}
          <span>{this.button_text}</span>
        </button>

        {/* Dropdown toggle button */}
        <button 
          type="button"
          class={toggleButtonClass}
          disabled={this.disabled}
          onClick={() => this.toggleSelect()}
        >
          <i class="material-icons" aria-hidden="true">
            {this.is_open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
          </i>
        </button>

        <div class={listClass} aria-hidden={!this.is_open} role="menu">
            <slot name="menu"></slot>
        </div>


        {/* {this.is_open && (
          <div class="split-btn-list">
            <slot name="menu"></slot>
          </div>
        )} */}
      </div>
    </Host>
  );
}
}
